import { render, staticRenderFns } from "./xxy-coupon-ranking-board.vue?vue&type=template&id=2a8fe9fa&scoped=true"
import script from "./xxy-coupon-ranking-board.vue?vue&type=script&lang=js"
export * from "./xxy-coupon-ranking-board.vue?vue&type=script&lang=js"
import style0 from "./xxy-coupon-ranking-board.vue?vue&type=style&index=0&id=2a8fe9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fe9fa",
  null
  
)

export default component.exports